import {createContext} from 'react';

import {TVehicleCreateContext} from './types/TVehicleCreateContext';

export const VehicleCreate = createContext<TVehicleCreateContext>({} as TVehicleCreateContext);
